import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Typography, Button, ViewColumnIcon, ViewListIcon, DialogProject, SMCard as Card, Paper, DataTable, makeStyles, Grid } from "../../../..";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    columnsContainer: {
      display: "flex",
      "justify-content": "space-between"
    },
    column: {
      display: "flex",
      flexDirection: "column",
      "align-items": "center",
      "min-height": "300px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between"
    },
    mr30: {
      margin: "30px"
    },
    title: {
      "text-align": "center",
      "font-weight": "bold",
      background: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      width: "300px",
      "border-radius": "4px 4px 0px 0px",
      padding: "5px 15px"
    },
    content: {
      width: "300px",
      background: "#7D7D7D",
      padding: "15px"
    },
    layoutOptions: {
      display: "flex",
      "justify-content": "flex-end",
      width: "97%",
      padding: "10px 0px"
    }
  };
});

var FranchiseProjectList = function FranchiseProjectList(_ref) {
  var projects = _ref.projects,
      onCardClick = _ref.onCardClick,
      options = _ref.options,
      translation = _ref.translation,
      opportunities = _ref.opportunities,
      contacts = _ref.contacts,
      numProjects = _ref.numProjects,
      totalBudget = _ref.totalBudget,
      templates = _ref.templates,
      createProject = _ref.createProject,
      onClick = _ref.onClick,
      currency = _ref.currency;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openProject = _useState2[0],
      setOpenProject = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showColumns = _useState4[0],
      setShowColumns = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      showDataTable = _useState6[0],
      setShowDataTable = _useState6[1];

  var classes = useStyles();

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      columns = _useState8[0],
      setColumns = _useState8[1];

  var createColumns = function createColumns(projects) {
    var columns = {
      plan: [],
      docheck: [],
      close: []
    };
    projects && projects.forEach(function (project) {
      return project.statusExecution && columns[project.statusExecution].push(project);
    });
    return columns;
  };

  useEffect(function () {
    projects && setColumns(createColumns(projects));
  }, [projects]);

  var handleDialogProject = function handleDialogProject() {
    setOpenProject(!openProject);
  };

  var handleShowColumns = function handleShowColumns() {
    if (!showColumns) {
      setShowColumns(true);
      setShowDataTable(false);
    }
  };

  var handleShowDataTable = function handleShowDataTable() {
    if (!showDataTable) {
      setShowColumns(false);
      setShowDataTable(true);
    }
  };

  var gridCol = columns && 12 / Object.keys(columns).length;
  return [/*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      color: "#fafafa"
    }
  }, translation ? translation.title : "Projects"), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "contained",
    onClick: handleDialogProject
  }, translation ? translation.buttons.add_project : "Projects"))), /*#__PURE__*/React.createElement(Grid, {
    className: classes.layoutOptions
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    "data-cy": "view-columns",
    onClick: handleShowColumns
  }, /*#__PURE__*/React.createElement(ViewColumnIcon, {
    fontSize: "default",
    color: showColumns ? "primary" : "inherit"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    "data-cy": "view-datatable",
    onClick: handleShowDataTable
  }, /*#__PURE__*/React.createElement(ViewListIcon, {
    fontSize: "default",
    color: showDataTable ? "primary" : "inherit"
  }))), columns && showColumns ? /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.columnsContainer
  }, Object.entries(columns).map(function (phase, i) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: gridCol,
      className: classes.column
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      className: classes.title
    }, translation.views.columns ? translation.views.columns.status[phase[0]] : Object.keys(columns)[i]), /*#__PURE__*/React.createElement(Paper, {
      className: classes.content
    }, phase[1].map(function (project) {
      return [/*#__PURE__*/React.createElement(Card, {
        data: project,
        onClick: onClick,
        link: "/projects/".concat(project._id, "/view")
      })];
    })));
  })) : /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 11
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: "_projects" // className={classes.datatable}
    ,
    type: "projects",
    data: projects,
    translation: translation ? translation.views.datatable : null
  })))), /*#__PURE__*/React.createElement(DialogProject, {
    open: openProject,
    translation: translation ? translation.dialogs.add_project : null,
    onClose: handleDialogProject,
    options: options,
    variant: "add",
    contacts: contacts,
    opportunities: opportunities,
    templates: templates,
    createProject: createProject,
    currency: currency
  })];
};

export default FranchiseProjectList;